import React, { createContext, useCallback, useContext, useState } from 'react';
import { clearToken, setToken } from '../services/tokenStore';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [token, setTokenState] = useState(null);

    const setAuth = useCallback((accessToken) => {
        setToken(accessToken);
        setTokenState(accessToken);
    }, []);

    const clearAuth = useCallback(() => {
        clearToken();
        setTokenState(null);
    }, []);

    return (
        <AuthContext.Provider value={{ token, setAuth, clearAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
